import React from 'react'
import { useTranslation } from 'react-i18next'

import { NumericInput } from '@/components/ui/numeric-input'
import { Typography } from '@/components/ui/typography'
import {
  MARKET_SHOP_MAX_TIP_AMOUNT,
  MARKET_SHOP_MIN_TIP_AMOUNT,
  MarketShopSettingsModel,
  NullableType,
} from '@/models'
import { transformCentsToDollars } from '@/utils'

import * as S from './tips.styled'

export interface TipsProps {
  prepopulatedTips: MarketShopSettingsModel['tips']
  prepopulatedTipValue: NullableType<number>
  customTipAmount: string
  onPrepopulatedTipClick: (newTip: number) => void
  onCustomTipAmountChange: (newValue: string) => void
}

export const Tips = ({
  prepopulatedTips,
  prepopulatedTipValue,
  customTipAmount,
  onPrepopulatedTipClick,
  onCustomTipAmountChange,
}: TipsProps) => {
  const { t } = useTranslation(['market-shop'])

  return (
    <S.Section>
      <Typography as="h2" size="heading-medium" weight="semibold" color="black800">
        {t('market-shop:tips.title')}
      </Typography>

      <S.TipOptions>
        <S.TipOption $active={prepopulatedTipValue === 0} onClick={() => onPrepopulatedTipClick(0)}>
          {t('market-shop:tips.noTip')}
        </S.TipOption>
        {prepopulatedTips.map((tip) => (
          <S.TipOption
            key={tip}
            $active={prepopulatedTipValue === tip}
            onClick={() => onPrepopulatedTipClick(tip)}
          >
            ${transformCentsToDollars(tip)}
          </S.TipOption>
        ))}
      </S.TipOptions>

      <S.CustomTip>
        <Typography size="text-medium" weight="medium" color="black800">
          {t('market-shop:tips.customValueLabel')}
        </Typography>
        <NumericInput
          id="custom-tip-amount"
          value={customTipAmount}
          min={MARKET_SHOP_MIN_TIP_AMOUNT}
          max={MARKET_SHOP_MAX_TIP_AMOUNT}
          decimalPlaces={2}
          mode="decimal"
          onChange={(value) => onCustomTipAmountChange(value)}
        />
      </S.CustomTip>
    </S.Section>
  )
}
